import * as React from "react"
import './Footer.scss'

const Header = ({ className }) => {
  return (
    <div className={"footer " + className}>
      <div className="container">
        <div className="copyright">
        <p> © {new Date().getFullYear()} | <a href={'https://human.games/'} rel="dofollow">Human Games</a></p>
        </div>
      </div>
    </div>
  )
}

export default Header
